var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter"},[_c('button',{staticClass:"counter__button",attrs:{"type":"button"},on:{"click":_vm.onDecrease}},[_c('MinusIcon')],1),_c('div',{staticClass:"counter__value"},[_vm._v(_vm._s(_vm.value))]),_c('button',{staticClass:"counter__button",attrs:{"type":"button"},on:{"click":_vm.onIncrease}},[_c('PlusIcon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }